<template>
   <v-app>
      <div class="animated fadeIn">

         <ddoWaiting :value="loading" :message="$t('texts.loading')"/>

         <v-switch
            dense
            v-model="listMode"
            @change="change_listMode"
            :label="$t('texts.list_mode')"
         >
         </v-switch>

         <ddoClientList key="StartingList1" v-if="!listMode" :loading="loading" :level="levels[0]" 
            :columns="levels[0].columns" :options="levels[0].options" :callbacks="levels[0].callbacks"
            :customSlotNames="levels[0].customSlotNames"
            @loading="refresh_loading"
            @childKey="refresh_childKey"
            @row="refresh_row"
            @errors="refresh_errors"
            >

            <template v-slot:superheader="{ errors }">
               <h1>{{ $t('titles.dtc') }}</h1>
            </template>

            <template v-slot:dialogform="{ row, level }">
               <CardUpdatableDatacenter :row="levels[0].row" :depth="levels[0].level" :level="levels[0]"
                  @errors="refresh_errors"
               />
            </template>

            <template v-slot:child_row="{ props }">
               <ddoClientList :loading="loading" :level="levels[1]" :childKey="levels[1].childKey"
                  :columns="levels[1].columns" :options="levels[1].options" :callbacks="levels[1].callbacks"
                  @childKey="refresh_childKey"
                  @row="refresh_row"
                  >

                  <template v-slot:superheader="slotProps">
                     <h2>{{ $api._format($t('subtitles.dtr'),slotProps.parentToggledRow['dtc_code']) }}</h2>
                  </template>

                  <template v-slot:dialogform="{ row, level }">
                     <CardUpdatableDatacenterrow :row="levels[1].row" :depth="levels[1].level" :level="levels[1]"/>
                  </template>

                  <template v-slot:child_row="{ props }">
                     <ddoClientList :loading="loading" :level="levels[2]" :childKey="levels[2].childKey"
                        :columns="levels[2].columns" :options="levels[2].options" :callbacks="levels[2].callbacks"
                        @childKey="refresh_childKey"
                        @row="refresh_row"
                        >
                        <template v-slot:superheader="slotProps">
                           <h3>{{ $api._format($t('subtitles.rck'),slotProps.parentToggledRow['dtr_code']) }}</h3>
                        </template>
                        <template v-slot:dialogform="{ row, level }">
                           <CardUpdatableRack :row="levels[2].row" :depth="levels[2].level" :level="levels[2]"/>
                        </template>

                        <template v-slot:child_row="{ props }">
                           <ddoClientList :loading="loading" :level="levels[3]" :childKey="levels[3].childKey"
                              :columns="levels[3].columns" :options="levels[3].options" :callbacks="levels[3].callbacks"
                              :customSlotNames="levels[3].customSlotNames"
                              @childKey="refresh_childKey"
                              @row="refresh_row"
                              ref="myEQUList"
                              >

                              <template v-slot:superheader="slotProps">
                                 <h3>{{ $api._format($t('subtitles.equ'),slotProps.parentToggledRow['rck_code']) }}</h3>
                              </template>

                              <template v-slot:header="slotProps">
                                 <v-row>
                                    <v-col sm="6">
                                       <v-btn @click="$refs.myEQUList.load_for_create()" class="primary" rounded :disabled="buttonAttachEQT"><v-icon large>mdi-plus</v-icon>CREER un Equipement Physique dy Type :</v-btn>
                                    </v-col>
                                    <v-col sm="6">
                                       <ddoSelectEquipmenttype :callbacks="EQTcallbacks" ref="mySelectEQT" :options="EQToptions"/>
                                    </v-col>
                                 </v-row>
                                 <v-row>
                                 <v-col sm="6">
                                    <v-btn @click="$refs.myEQUList.load_for_update(selectedEQU,'attach')" class="primary" rounded :disabled="buttonAttachEQU"><v-icon large>mdi-plus</v-icon>ATTACHER un Equipement Physique existant :</v-btn>
                                 </v-col>
                                 <v-col sm="6">
                                    <ddoSelectEquipment :callbacks="EQUcallbacks" ref="mySelectEQU" :options="EQUoptions"/>
                                 </v-col>
                                 </v-row>
                              </template>

                              <template slot="equ_position_from" slot-scope="props">
                                 <template v-if="props.row.equ_position_from!=null">
                                    <br/>
                                    <v-range-slider
                                       v-model="props.row.equ_positions"
                                       class="align-center"
                                       :max="props.row.rck_size_u"
                                       :min="1"
                                       thumb-label="always"
                                       thumb-size=24
                                       readonly
                                       dense
                                    >
                                    </v-range-slider>
                                 </template>
                              </template>

                              <template v-slot:dialogform="{ row, level }">
                                 <CardUpdatableEquipment key="UpdateEQU1" :row="levels[3].row" ref="myCardEquipment" :depth="levels[3].level" :level="levels[3]"/>
                              </template>

                           </ddoClientList>
                        </template>

                     </ddoClientList>
                  </template>
               </ddoClientList>
            </template>

         </ddoClientList>

         <ddoClientList name="StartingList2" key="StartingList2" v-if="listMode" :loading="loading" :level="levels[4]"
            :columns="levels[4].columns" :options="levels[4].options" :callbacks="levels[4].callbacks"
            :customSlotNames="levels[4].customSlotNames"
            @childKey="refresh_childKey"
            @row="refresh_row"
            ref="myEQUList2"
            >

            <template v-slot:superheader="slotProps">
               <h3>{{ $t('titles.equ') }}</h3>
            </template>

            <template slot="searchengine" slot-scope="props">
               <v-card outlined max-width="400">
                  <h4>{{ $t('subtitles.filters') }} :</h4>
                  <v-col>
                  <p>
                     <b-radio-group id="eqt_is_virtual" v-model="levels[4].searchValues.eqt_is_virtual" label="Virtuel/Physique" @change="filter_rows(4)">
                        <b-radio value="">Tous</b-radio>
                        <b-radio value="true">Virtuel</b-radio>
                        <b-radio value="false">Physique</b-radio>
                        <b-radio value="compute">"Compute"</b-radio>
                     </b-radio-group>
                  </p>
                  <p>
                     <v-text-field v-model="levels[4].searchValues.equ_name" :label="$t('texts.equ_name')" @change="filter_rows(4)">
                     </v-text-field>
                  </p>
                  </v-col>
               </v-card>
            </template>

            <template slot="equ_location" slot-scope="props">
               <template v-if="props.row.rck_pk!=null">
                  <v-chip><span>{{ props.row.dtc_code }} / {{ props.row.dtr_code }} / {{ props.row.rck_code }}</span></v-chip>
               </template>
            </template>

            <template slot="equ_position_from" slot-scope="props">
               <template v-if="props.row.equ_position_from!=null">
                  <br/>
                  <v-range-slider
                     v-model="props.row.equ_positions"
                     class="align-center"
                     :max="props.row.rck_size_u"
                     :min="1"
                     thumb-label="always"
                     thumb-size=24
                     readonly
                     dense
                  >
                  </v-range-slider>
               </template>
            </template>

            <template v-slot:dialogform="{ row, level }">
               <CardUpdatableEquipment key="UpdateEQU2" :row="levels[4].row" ref="myCardEquipment" :depth="levels[4].level" :level="levels[4]"/>
            </template>

         </ddoClientList>

      </div>
   </v-app>
</template>

<script>
import Vue from 'vue';
import i18n from '@/plugins/i18n.js';
import ddoAlert from '@/components/ddoAlert.vue';
import ddoWaiting from '@/components/ddoWaiting.vue'
import ddoClientList from '@/components/ddoClientList.vue';
import { Event } from '@/components/ddoClientList.vue';

import CardUpdatableDatacenter from '@/components/partials/CardUpdatableDatacenter.vue';
import CardUpdatableDatacenterrow from '@/components/partials/CardUpdatableDatacenterrow.vue';
import CardUpdatableRack from '@/components/partials/CardUpdatableRack.vue';
import CardUpdatableEquipment from '@/components/partials/CardUpdatableEquipment.vue';
import ddoSelect2 from '@/components/ddoSelect2.vue';
import ddoSelectEquipment from '@/components/ddoSelectEquipment.vue';
import ddoSelectEquipmenttype from '@/components/ddoSelectEquipmenttype.vue';

let initial_row = {}

Vue.use(Event);

export default {
   name: 'equipment',
   components: {
      ddoAlert,
      ddoWaiting,
      ddoClientList,
      CardUpdatableDatacenter,
      CardUpdatableDatacenterrow,
      CardUpdatableRack,
      CardUpdatableEquipment,
      ddoSelect2,
      ddoSelectEquipment,
      ddoSelectEquipmenttype,
   },
   data: () => {
      return {
         _this: null,
         loading: false,
         listMode: true,

         buttonAttachEQU: true,
         selectedEQU: {},
         EQUcallbacks: {},
         // DO NOT USE 'return_object: true' on EQUoptions
         EQUoptions: {
            initial: null,
            selected: null,
            required: true,
            disabled: false,
            multiple: false,
            clearable: false,
            item_text: "equ_name",
            item_value: "equ_pk",
            item_disabled: "",
            hide_selected: true,
            change_on_remove: true,
            label: i18n.t('texts.equipment'),
         },

         buttonAttachEQT: true,
         selectedEQT: {},
         EQTcallbacks: {},
         // DO NOT USE 'return_object: true' on EQToptions
         EQToptions: {
            initial: null,
            selected: null,
            required: true,
            disabled: false,
            multiple: false,
            clearable: false,
            item_text: "eqt_name",
            item_value: "eqt_pk",
            item_disabled: "",
            hide_selected: true,
            change_on_remove: true,
            label: i18n.t('texts.equipmenttype'),
         },

         levels: [
         /* 
          * LEVEL 1 : all for ddoClientList : columns, options, callbacks
          */
         {
            api_code: 'datacenter',
            api_prefix: 'dtc',
            row: {},
            level: 0,
            errors: [],
            columns: [ '_actions', 'dtc_code', 'dtc_address', 'dtc_desc', '_update'],
            options: {
               showChildRowToggler: false,
               preserveState: true,
               withChild: true,
               hiddenColumns: [],
               headings: {
                  _pk: i18n.t('headers.actions'),
                  _child: i18n.t('headers.actions'),
                  dtc_pk: '#',
                  dtc_code: i18n.t('headers.code'),
                  dtc_address: i18n.t('texts.dtc_address'),
                  dtc_desc: i18n.t('headers.description'),
                  _update: i18n.t('headers.updated_on')
               },
               texts: {
               },
               uniqueKey: 'dtc_pk',
               sortable: ['dtc_code','dtc_update'],
               filterable: false,
               sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
               columnsDropdown: false,
               pagination: {
                  chunk: 5,
                  edge: false,
                  nav: 'scroll'
               },
            },
            callbacks: {
            },
            dialogOptions: {
               codeRules : [
                  (v) => !!v || i18n.t('texts._required')
               ]
            },
            dialogValues: {
               headers: {
                  create: i18n.t('texts.dtc_create_title'),
                  update: i18n.t('texts.dtc_update_title'),
                  delete: i18n.t('texts.dtc_delete_title'),
               },
               dialogShow: false,
               form_disabled: false,
               form_close: true,
               form_create: false,
               form_update: false,
               form_delete: false,
               disable_create: false,
               disable_update: false,
               disable_delete: false,
               header_value_function: function(row) { return row['dtc_code']; }
            },
         },

         {
            /* 
            * LEVEL 2 : all for ddoClientList : columns_l2, options_l2, callbacks_l2
            */
            api_code: 'datacenterrow',
            api_prefix: 'dtr',
            row: {},
            level: 1,
            errors: [],
            columns: [ '_actions', 'dtr_code', 'dtr_location', 'dtr_desc', '_update' ],
            nestedSlots: [],
            options: {
               showChildRowToggler: false,
               withChild: true,
               headings: {
                  _pk: i18n.t('headers.actions'),
                  _child: i18n.t('headers.actions'),
                  dtr_pk: '#',
                  dtr_code: 'Code',
                  dtr_desc: i18n.t('headers.description'),
                  dtr_location: i18n.t('texts.dtr_location'),
                  _update: i18n.t('headers.updated_on')
               },
               filterable: false,
               sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
               uniqueKey: 'dtr_pk'
            },
            callbacks: {
            },
            dialogOptions: {
               codeRules : [
                  (v) => !!v || i18n.t('texts._required')
               ]
            },
            dialogValues: {
               headers: {
                  create: i18n.t('texts.dtr_create_title'),
                  update: i18n.t('texts.dtr_update_title'),
                  delete: i18n.t('texts.dtr_delete_title'),
               },
               dialogShow: false,
               form_disabled: false,
               form_close: true,
               form_create: false,
               form_update: false,
               form_delete: false,
               disable_create: false,
               disable_update: false,
               disable_delete: false,
               parentKeyName: 'dtc_pk',
               header_value_function: function(row) { return row['dtr_code']; }
            },
         },

         {
            /* 
               * LEVEL 3 : all for ddoClientList : columns_l3, options_l3, callbacks_l3
               */
            api_code: 'rack',
            api_prefix: 'rck',
            row: {},
            level: 2,
            errors: [],
            columns: [ '_actions', 'rck_code', 'rck_position', 'rck_size_u', 'rck_depth_mm', 'rck_width_mm', '_count', '_update' ],
            nestedSlots: [],
            options: {
               showChildRowToggler: false,
               withChild: true,
               headings: {
                  _child: i18n.t('headers.actions'),
                  _pk: i18n.t('headers.actions'),
                  dtr_pk: '#',
                  rck_code: 'Code',
                  rck_position: i18n.t('texts.rck_position'),
                  rck_size_u: i18n.t('texts.rck_size_u'),
                  rck_depth_mm: i18n.t('texts.rck_depth_mm'),
                  rck_width_mm: i18n.t('texts.rck_width_mm'),
                  _count: i18n.t('headers.equ_count'),
                  _update: i18n.t('headers.updated_on'),
               },
               filterable: false,
               sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
               uniqueKey: 'rck_pk'
            },
            callbacks: {
            },
            dialogOptions: {
               codeRules : [
                  (v) => !!v || i18n.t('texts._required')
               ]
            },
            dialogValues: {
               headers: {
                  create: i18n.t('texts.rck_create_title'),
                  update: i18n.t('texts.rck_update_title'),
                  delete: i18n.t('texts.rck_delete_title'),
               },
               dialogShow: false,
               form_disabled: false,
               form_close: true,
               form_create: false,
               form_update: false,
               form_delete: false,
               disable_create: false,
               disable_update: false,
               disable_delete: false,
               parentKeyName: 'dtr_pk',
               header_value_function: function(row) { return row['rck_code']; }
            },
         },

         {
            /* 
            * LEVEL 4 : all for ddoClientList : columns_l4, options_l4, callbacks_l4
            */
            api_code: 'equipment',
            api_prefix: 'equ',
            row: {},
            level: 3,
            errors: [],
            columns: [ '_actions', 'equ_pk', 'equ_name', 'eqt_name', 'equ_position_from', '_update' ],
            customSlotNames: ['equ_position_from'],
            options: {
               showChildRowToggler: false,
               preserveState: true,
               withChild: false,
               headings: {
                  _pk: i18n.t('headers.actions'),
                  equ_pk: '#',
                  equ_code: 'UUID',
                  equ_name: i18n.t('texts.equ_name'),
                  eqt_name: i18n.t('texts.eqt_name'),
                  equ_position_from: i18n.t('headers.equ_position_from'),
                  _update: i18n.t('headers.updated_on'),
               },
               filterable: false,
               sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
               uniqueKey: 'equ_pk'
            },
            callbacks: {
            },
            dialogOptions: {
               codeRules : [
                  (v) => !!v || i18n.t('texts._required')
               ]
            },
            dialogValues: {
               headers: {
                  create: i18n.t('texts.equ_create_title'),
                  update: i18n.t('texts.equ_update_title'),
                  delete: i18n.t('texts.equ_delete_title'),
               },
               dialogShow: false,
               form_disabled: false,
               form_close: true,
               form_create: false,
               form_update: false,
               form_delete: false,
               disable_create: false,
               disable_update: false,
               disable_delete: false,
               parentKeyName: 'rck_pk',
               header_value_function: function(row) { return row['equ_name']; }
            },
         },

         {
            /* 
             * LEVEL 5 : all for ddoClientList : columns_l5, options_l5, callbacks_l5
             */
            api_code: 'equipment',
            api_prefix: 'equ',
            row: {},
            level: 4,
            errors: [],
            columns: [ '_actions', 'equ_name', 'eqt_name', 'equ_location', 'equ_position_from', '_update' ],
            customSlotNames: ['equ_location','equ_position_from'],
            searchValues: {
               eqt_is_virtual: null,
               equ_name: null,
            },
            options: {
               showChildRowToggler: false,
               preserveState: true,
               withChild: false,
               headings: {
                  _pk: i18n.t('headers.actions'),
                  equ_pk: '#',
                  equ_name: i18n.t('texts.equ_name'),
                  eqt_name: i18n.t('texts.eqt_name'),
                  equ_location: i18n.t('headers.equ_location'),
                  equ_position_from: i18n.t('headers.equ_position_from'),
                  _update: i18n.t('headers.updated_on'),
               },
               filterable: false,
               customFilters: [{
                  name: 'search',
                  callback: function (row, query) {
                     let $ret = true;
                     //console.log('callback, row='+JSON.stringify(row));
                     //console.log('callback, query='+JSON.stringify(query));
                     if ( $ret && query.eqt_is_virtual!=null ) {
                        if ( query.eqt_is_virtual=="true"    && !row.eqt_is_virtual ) { $ret = false; }
                        if ( query.eqt_is_virtual=="false"   && row.eqt_is_virtual ) { $ret = false; }
                        if ( query.eqt_is_virtual=="compute" && ( row.eqt_is_virtual || !row.eqt_is_a_compute ) ) { $ret = false; }
                     }
                     if ( $ret && query.equ_name!=null ) {
                        if ( row.equ_name.indexOf(query.equ_name)<0 ) { $ret = false; }
                     }
                     //console.log('callback, name='+row.equ_name+'/'+row.eqt_is_a_compute+'/'+row.eqt_is_virtual+', ret='+$ret)
                     return $ret;
                  }
               }],
               sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
               uniqueKey: 'equ_pk'
            },
            callbacks: {
            },
            dialogOptions: {
               codeRules : [
                  (v) => !!v || i18n.t('texts._required')
               ]
            },
            dialogValues: {
               headers: {
                  create: i18n.t('texts.equ_create_title'),
                  update: i18n.t('texts.equ_update_title'),
                  delete: i18n.t('texts.equ_delete_title'),
               },
               dialogShow: false,
               form_disabled: false,
               form_close: true,
               form_create: false,
               form_update: false,
               form_delete: false,
               disable_create: false,
               disable_update: false,
               disable_delete: false,
               header_value_function: function(row) { return row['equ_name']; },
               parentKeyName: null,
           },
         },

         ],

         model: {},
         dialogShow: false,
         dialogId: null,
         dialogcode: null,

         useVuex: false,
         theme: 'bootstrap4',
         template: 'default',
      }
   },

   created() {
      this._this = this;

      this.levels[0].callbacks.configure_form = this.configure_form;
      this.levels[0].callbacks.show_dialog    = this.show_dialog;
      this.levels[0].callbacks.refresh_errors = this.refresh_errors;

      this.levels[1].callbacks.refresh_rows   = this.refresh_rows_l2;
      this.levels[1].callbacks.prepare_create = this.prepare_create_l2;    
      this.levels[1].callbacks.configure_form = this.configure_form;
      this.levels[1].callbacks.show_dialog    = this.show_dialog;
      this.levels[1].callbacks.refresh_errors = this.refresh_errors;

      this.levels[2].callbacks.refresh_rows   = this.refresh_rows_l3;
      this.levels[2].callbacks.prepare_create = this.prepare_create_l3;
      this.levels[2].callbacks.configure_form = this.configure_form;
      this.levels[2].callbacks.show_dialog    = this.show_dialog;
      this.levels[2].callbacks.refresh_errors = this.refresh_errors;

      this.levels[3].callbacks.refresh_rows   = this.refresh_rows_l4;
      this.levels[3].callbacks.prepare_create = this.prepare_create_l4;
      this.levels[3].callbacks.prepare_update = this.prepare_update_l4;
      this.levels[3].callbacks.create_row     = this.create_row_l4;
      this.levels[3].callbacks.update_row     = this.update_row_l4;
      this.levels[3].callbacks.configure_form = this.configure_form;
      this.levels[3].callbacks.show_dialog    = this.show_dialog;
      this.levels[3].callbacks.refresh_errors = this.refresh_errors;

      this.levels[4].callbacks.refresh_rows   = this.refresh_rows_l5;
      this.levels[4].callbacks.prepare_create = this.prepare_create_l4;
      this.levels[4].callbacks.prepare_update = this.prepare_update_l5;
      this.levels[4].callbacks.create_row     = this.create_row_l4;
      this.levels[4].callbacks.update_row     = this.update_row_l4;
      this.levels[4].callbacks.configure_form = this.configure_form;
      this.levels[4].callbacks.show_dialog    = this.show_dialog;
      this.levels[4].callbacks.refresh_errors = this.refresh_errors;

      this.EQUcallbacks.refresh_rows = this.build_select_equ;
      this.EQUcallbacks.change       = this.change_equ;

      this.EQTcallbacks.refresh_rows = this.build_select_eqt;
      this.EQTcallbacks.change       = this.change_eqt;

      this.buttonAttachEQT = true;
      this.buttonAttachEQU = true;
   },

   methods: {

      async change_listMode(value) {
         console.log('change_listMode, value='+value)
         if ( value===true ) {
            this.levels[4].errors = [];
            this.levels[4].rows = [];
         } else {
            this.levels[0].errors = [];
            this.levels[0].rows = [];
         }
      },

      build_positions(row) {
         console.log('build_positions')
      },

      refresh_loading(value) {
         this.loading = value;
      },
      refresh_errors(level,errors) {
         this.levels[level].errors = errors;
      },
      refresh_row(level,row) {
         this.levels[level].row = row;
      },

      async refresh_rows_l1(key) {
         this.loading = true;
         let { errorinfos, api_response } = await this.$api.getRows(this.$router,this.levels[0].api_code);
         this.loading = false;
         return { errorinfos, api_response }
      },

      async refresh_rows_l2(key) {
         this.loading = true;
         let { errorinfos, api_response } = await this.$api.getRows(this.$router,this.levels[0].api_code+'/'+key+'/rows');
         this.loading = false;
         return { errorinfos, api_response }
      },

      async refresh_rows_l3(key) {
         this.loading = true;
         let { errorinfos, api_response } = await this.$api.getRows(this.$router,this.levels[1].api_code+'/'+key+'/racks');
         this.loading = false;
         return { errorinfos, api_response }
      },

      async refresh_rows_l4(key) {
         this.loading = true;
         let { errorinfos, api_response } = await this.$api.getRows(this.$router,this.levels[2].api_code+'/'+key+'/equipments');
         this.loading = false;
         if ( api_response.error==0 && api_response.rows ) {
            for( var i=0;i<api_response.rows.length;i++ ) {
               let min = api_response.rows[i].equ_position_from;
               let max = api_response.rows[i].equ_position_to;
               min = ( min!=null ? min : 0 );
               max = ( max!=null ? max : min);
               api_response.rows[i].equ_position_to = max;
               api_response.rows[i].equ_positions = [ min, max ];
            }
         }
         return { errorinfos, api_response }
      },

      async refresh_rows_l5(key) {
         this.loading = true;
         let { errorinfos, api_response } = await this.$api.getRows(this.$router,this.levels[4].api_code);
         this.loading = false;
         if ( api_response.error==0 && api_response.rows ) {
            for( var i=0;i<api_response.rows.length;i++ ) {
               let min = api_response.rows[i].equ_position_from;
               let max = api_response.rows[i].equ_position_to;
               min = ( min!=null ? min : 0 );
               max = ( max!=null ? max : min);
               api_response.rows[i].equ_position_to = max;
               api_response.rows[i].equ_positions = [ min, max ];
            }
         }
         return { errorinfos, api_response }
      },

      refresh_childKey(level,key,toggledRow=null) {
         this.levels[level].childKey = key;
         this.levels[level].toggledRow = toggledRow;
      },

      configure_form(level,f_disabled,f_create,f_update,f_delete) {
         let _dV = this.levels[level].dialogValues;
         _dV.form_disabled = f_disabled;
         _dV.form_create   = f_create;
         _dV.form_update   = f_update;
         _dV.form_delete   = f_delete;
         this.levels[level].dialogValues = _dV;
      },

      show_dialog(level,show) {
         let _dV = this.levels[level].dialogValues;
         _dV.header_value = _dV.header_value_function(this.levels[level].row);
         _dV.dialogShow   = show;
         this.levels[level].dialogValues = _dV;
      },

      prepare_create_l2(parentKey=null,origin=null) {
         this.levels[1].errors = [];
         if ( this.levels[1].dialogValues.parentKeyName ) {
            this.levels[1].row[this.levels[1].dialogValues.parentKeyName] = parentKey;
         } 
      },

      prepare_create_l3(parentKey=null,origin=null) {
         this.levels[2].errors = [];
         if ( this.levels[2].dialogValues.parentKeyName ) {
            this.levels[2].row[this.levels[2].dialogValues.parentKeyName] = parentKey;
         } 
      },

      prepare_create_l4(parentKey=null,origin=null) {
         this.levels[3].errors = [];
         this.levels[3].row = {};
         if ( this.levels[3].toggledRow ) {
            this.levels[3].row.rck_pk     = this.levels[3].toggledRow.rck_pk;   
            this.levels[3].row.rck_size_u = this.levels[3].toggledRow.rck_size_u;   
         }
         this.levels[3].row.eqt_pk = this.selectedEQT;
         this.levels[3].row.eqt_is_virtual = false;
         this.levels[3].row.equ_on_front = true;
         this.levels[3].row.equ_autocreated = false;
         this.$refs.myCardEquipment.EQToptions.selected  = this.levels[3].row.eqt_pk;
         this.$refs.myCardEquipment.RCKoptions.selected  = this.levels[3].row.rck_pk;
      },

      prepare_update_l4(parentKey=null,_pk,row=null,origin=null) {
         this.levels[3].errors = [];
         if ( origin=='attach' && this.levels[3].toggledRow ) {
            this.levels[3].row.rck_pk     = this.levels[3].toggledRow.rck_pk;   
            this.levels[3].row.rck_size_u = this.levels[3].toggledRow.rck_size_u;   
         }
         //this.levels[3].row._pk = this.selectedEQU;
         this.levels[3].row.eqt_is_virtual = false;
         if ( this.levels[3].row.equ_on_front==null ) {
            this.levels[3].row.equ_on_front = true;
         }
         this.$refs.myCardEquipment.EQToptions.selected  = this.levels[3].row.eqt_pk;
         this.$refs.myCardEquipment.RCKoptions.selected  = this.levels[3].row.rck_pk;
      },

      prepare_update_l5(parentKey=null,_pk,row=null,origin=null) {
         this.levels[4].errors = [];
         this.levels[4].row.eqt_is_virtual = false;
         if ( this.levels[4].row.equ_on_front==null ) {
            this.levels[4].row.equ_on_front = true;
         }
         this.$refs.myCardEquipment.EQToptions.selected  = this.levels[4].row.eqt_pk;
         this.$refs.myCardEquipment.RCKoptions.selected  = this.levels[4].row.rck_pk;
      },

      async create_row_l4(router,api_code,row) {
         if ( row.equ_positions && row.equ_positions.length==2 ) {
            row.equ_position_from = row.equ_positions[0];
            row.equ_position_to   = row.equ_positions[1];
         }
         var { errorinfos, api_response } = await this.$api.createRow(router,api_code,row);
         return { errorinfos, api_response }
       },

      async update_row_l4(router,api_code,_pk,row) {
         console.log('update_row_l4, _pk='+_pk);
         if ( row.equ_positions && row.equ_positions.length==2 ) {
            row.equ_position_from = row.equ_positions[0];
            row.equ_position_to   = row.equ_positions[1];
         }
         var { errorinfos, api_response } = await this.$api.updateRow(router,api_code,_pk,row);
         return { errorinfos, api_response }
       },

      /*
       * Build Equipments List, but only physical Equipments
       */
      async build_select_equ(key=null) {
         this.loading = true;
         var data = { search: JSON.stringify({eqt_is_virtual: false}) }; 
         var { errorinfos, api_response } = await this.$api.getRows(this.$router,'equipment', data);
         this.loading = false;
         return { errorinfos, api_response }
      },

      /*
       * Build Equipments List, but only physical Equipments
       */
      async change_equ(value,item=null) {
         console.log('change_equ, value='+value+', item='+JSON.stringify(item));
         if ( item!=null ) {
            this.selectedEQU = item;
         } else {
            this.selectedEQU = value;
            this.buttonAttachEQU = ( value==null ? true : false);
         }
      },

      /*
       * Build EquipmentTypes List, but only physical EquipmentTypes
       */
      async build_select_eqt(key=null) {
         console.log('build_select_eqt')
         this.loading = true;
         var data = { search: JSON.stringify({eqt_is_virtual: false}) }; 
         var { errorinfos, api_response } = await this.$api.getRows(this.$router,'equipmenttype', data);
         this.loading = false;
         return { errorinfos, api_response }
      },

      async change_eqt(value,item=null) {
         console.log('change_eqt, value='+value+', item='+JSON.stringify(item));
         if ( item!=null ) {
            this.selectedEQT = item;
         } else {
            this.selectedEQT = value;
            this.buttonAttachEQT = ( value==null ? true : false);
         }
        console.log('change_eqt, selectedEQT='+this.selectedEQT);
      },

      filter_rows(level) {
         console.log('filter_rows, searchValues='+JSON.stringify(this.levels[level].searchValues))
         Event.$emit('vue-tables.filter::search', this.levels[level].searchValues);
      },
   }
}
</script>